export default class InformationsController {
  /** @ngInject */
  constructor(
    $log, $state,
    me
  ) {
    this.$log = $log;
    this.$state = $state;
    this.me = me;

    this.currentStateName = this.$state.current.name;
  }
}
